export const ALL_SCORE_PROVIDERS = {
  creditsafeconnect: ['Credit Safe', 'Creditsafe Connect'],
  creditsafe: ['Credit Safe'],
  ellisphere: ['Ellisphere'],
  fircosoft: ['Criblage (Fircosoft)'],
  ciscar: ['Ciscar'],
  companyweb: ['Company Web'],
  informa: ['Informa'],
  pappers: ['Pappers'],
  leasing: ['NOVALEND LEASING'],
}
